import { getFovy } from '../../../godot/math/projection.js';
import { radToDeg } from '../../../godot/math/math.js';
import { Camera3DKeepAspect, Camera3DProjectionType } from '../../../godot/scene/camera3d.js';
/** Records the lens that `fitToAspect` reads. The aspect of an earlier fit stays. */
export function setLens(camera, lens) {
    const fittable = camera;
    fittable.userData.lensFit = { lens, aspect: fittable.userData.lensFit?.aspect ?? null };
}
/** Rebuilds the projection for `aspect`. A camera with no lens is not a Camera3D, so it stays. */
export function fitToAspect(camera, aspect) {
    const fittable = camera;
    const fit = fittable.userData.lensFit;
    if (!fit)
        return;
    fit.aspect = aspect;
    if (fittable.isOrthographicCamera)
        fitOrthographic(camera, fit.lens, aspect);
    if (fittable.isPerspectiveCamera)
        fitPerspective(camera, fit.lens, aspect);
    // After the perspective fit, which sets the aspect the frustum's width reads.
    if (fit.lens.projection === Camera3DProjectionType.FRUSTUM) {
        fitFrustum(camera, fit.lens, aspect);
    }
}
/** The aspect of the last fit, or null for a camera never fitted. */
export function fittedAspect(camera) {
    return camera.userData.lensFit?.aspect ?? null;
}
/** `Projection::set_orthogonal` (`projection.cpp:356-362`): `size` is the full kept extent. */
function fitOrthographic(camera, lens, aspect) {
    const width = lens.keepAspect === Camera3DKeepAspect.KEEP_WIDTH ? lens.size : lens.size * aspect;
    camera.left = -width / 2;
    camera.right = width / 2;
    camera.top = width / aspect / 2;
    camera.bottom = -width / aspect / 2;
    camera.updateProjectionMatrix();
}
/** three's fov is vertical. Under KEEP_WIDTH Godot's is horizontal (`projection.cpp:252-255`). */
function fitPerspective(camera, lens, aspect) {
    camera.fov = lens.keepAspect === Camera3DKeepAspect.KEEP_WIDTH ? getFovy(lens.fov, 1 / aspect) : lens.fov;
    camera.aspect = aspect;
    camera.updateProjectionMatrix();
}
/**
 * `Projection::set_frustum` (`projection.cpp:396-402`), which `camera_3d.cpp:280` calls without
 * `keep_aspect`: `size` is the height at the near plane, the width is `size × aspect`, and
 * `frustum_offset` shifts both in near-plane units. three's view offset holds the shift, so a later
 * `updateProjectionMatrix` keeps it.
 */
function fitFrustum(camera, lens, aspect) {
    const height = lens.size;
    const width = lens.size * aspect;
    camera.fov = radToDeg(2 * Math.atan(height / 2 / camera.near));
    camera.setViewOffset(width, height, lens.frustumOffset.x, -lens.frustumOffset.y, width, height);
}
//# sourceMappingURL=projectionFit.js.map